<template lang="pug">
  .sys-bar(:class="backable? 'backable': ''")
    .status-bar(:style="`height: ${sysInfo.statusBarHeight}px`")
    .title-bar(:style="`height: ${sysInfo.titleBarHeight}px`")
      .back-btn(@click="onBack")
        .wrapper
          img(src="~assets/back.png")
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SysBar',
  props: {
    backable: {
      default: false,
    },
  },
  computed: {
    ...mapState('app', ['sysInfo', 'router']),
  },
  mounted() {
    console.log(
      'sys bar',
      this.sysInfo.statusBarHeight,
      this.sysInfo.titleBarHeight
    )
  },
  methods: {
    pxToRem(px) {
      return `${px * 0.02}rem`
    },
    onBack() {
      let exhibitPage = /^\/introduction\/intro\/[0-5]$/
      let isExhibitPage = exhibitPage.test(this.$route.path)
      if (this.$route.path !== this.router.back) {
        if (isExhibitPage) {
          console.log('匹配到展项返回页了')
          this.$router.replace('/introduction/intro')
        } else this.$router.replace(this.router.back)
      }
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.sys-bar
  width: 100%
  .status-bar
    width: 100%
    //background: black
  .title-bar
    width: 100%
    //background: aqua
    .back-btn
      //background: red
      margin-left: pxToRem(88)
      width: pxToRem(44)
      height: 100%
      display: none
      position: relative
      //background: red
      .wrapper
        z-index: 999
        //background: #1664FF
        opacity: 1
        width: 300%
        height: 300%
        position: relative
        top: -100%
        left: -100%
        display: flex
        justify-content: center
        align-items: center
        img
          height: pxToRem(44)
          object-fit: contain
          //background: #3a54a2
  &.backable
    background: #fff
    .title-bar
      .back-btn
        display: block
        //display: flex
        //justify-content: center
        //align-items: center
</style>
